import Vue from "vue";

Vue.filter("toTwoDecimal", function (d) {
  if (typeof d != "undefined") {
    return Number(d).toFixed(2);
  }
});
